import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CalendarCheck } from "lucide-react";

const COPY = {
  demo: ["Demo booked", "Our team will reach out shortly to confirm your time."],
  trial: ["Request received", "Our team will reach out shortly to get you set up."],
  custom_quote: ["Quote requested", "Our team will review your volume and send a tailored Custom quote shortly."],
};

export const DemoBookedVideo = ({ booked, onClose }) => {
  const [badge, line] = COPY[booked?.intent] || COPY.demo;
  return (
    <Dialog open={!!booked} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="demo-booked-video-dialog" className="max-w-4xl w-[95vw] max-h-[92vh] overflow-y-auto p-0 bg-ally-ink border border-white/10 rounded-[24px] text-white">
        <div className="px-6 sm:px-8 pt-6 pb-4">
          <div className="inline-flex items-center gap-2 bg-ally-pink/15 text-ally-pink rounded-full px-3 py-1 text-xs font-bold uppercase tracking-widest" data-testid="demo-booked-badge">
            <CalendarCheck size={13} /> {badge}
          </div>
          <DialogTitle className="font-display text-2xl sm:text-3xl font-bold mt-3" data-testid="demo-booked-title">
            You're all set, {(booked?.name || "").split(" ")[0]}.
          </DialogTitle>
          <DialogDescription className="text-white/60 text-sm sm:text-base mt-1">
            {line} While you wait, here's a 2-minute look at DeferAlly.
          </DialogDescription>
        </div>
        <video data-testid="demo-booked-video" src="/vsl/DeferAlly-VSL-v3.mp4" poster="/vsl/DeferAlly-VSL-poster.jpg"
          controls autoPlay playsInline preload="metadata" className="w-full aspect-video bg-black rounded-b-[24px]" />
      </DialogContent>
    </Dialog>
  );
};
